@if (order$ | async; as order) {
  <div class="order-details-headline">
    <div class="cx-header row">
      @if (order?.code) {
        <div class="cx-detail col-sm-6 col-md-4">
          <div class="cx-detail-label">{{ 'orderDetails.orderId' | cxTranslate }}</div>
          <div class="cx-detail-value">{{ order?.code }}</div>
        </div>
      }
      @if (order?.created) {
        <div class="cx-detail col-sm-6 col-md-4">
          <div class="cx-detail-label">Placed</div>
          <div class="cx-detail-value">{{ order?.created | cxDate }}</div>
        </div>
      }
      @if (order?.statusDisplay) {
        <div class="cx-detail col-sm-12 col-md-4 cancel-order">
          <div>
            <div class="cx-detail-label">{{ 'orderDetails.status' | cxTranslate }}</div>
            <div class="cx-detail-value">
              <app-order-status
                [order]="isCancelling ? tempOrder : order"
                [forceStatus]="isCancelling ? OrderStatus.CANCELLED : null"
                >
              </app-order-status>
            </div>
          </div>
          @if (showCancelOrder(order)) {
            <button
              class="btn btn-danger btn-small"
              (click)="onCancelOrder(order)"
              [disabled]="disableOnCancel"
              >
              @if (spinner) {
                <i class="fa fa-spinner fa-spin"></i>
              }
              Cancel Order
            </button>
          }
        </div>
      }
    </div>
  </div>
}
